export const FIELDS: Record<string, string> = {
  'sfa_id': 'ID СФА',  
  'current_sfa_id': 'ID TT в SFA',
  'dist_system_id': 'ID ТТ в системе дистрибьютора',
  'sales_source': 'Источник продаж',
  'sales_outlet_id': 'ID ТТ источника продаж',
  'legal_name': 'Юр. наименование',
  'name': 'Наименование',
  'subnet': 'Подсеть',
  'title': 'Вывеска',
  'room_type': 'Тип',
  'inn': 'ИНН',
  'ogrn': 'ОГРН',
  'division': 'Дивизион',
  'distributor': 'Дистрибьютор',
  'segment': 'Сегмент',
  'sub_channel': 'Подканал',
  'channel': 'Канал',
  'visits_frequency': 'Частота посещений',
  'visits_day': 'Дни посещения',
  'route_number': 'Маршрут',
  'legal_address': 'Юр. адрес',
  'address': 'Фактический адрес',
  'full_address': 'Фактический адрес',
  'region': 'Регион',
  'city': 'Город',
  'price': 'Прайс-лист',
  'payment_type': 'Тип оплаты',
  'payment_deferment': 'Отсрочка платежа',
  'kpp': 'КПП',
  'okpo': 'ОКПО',
  'bic': 'БИК',
  'corr_account': 'Кор.счет',
  'account': 'Р.счет',
  'director': 'Директор',
  'phone': 'Телефон',
  'email': 'Email',
  'contact_person_1': 'Контактное лицо (1)',
  'contact_person_2': 'Контактное лицо (2)',
  'status': 'Статус',
  'open_date': 'Дата открытия',
  'close_date': 'Дата закрытия',
};